import styled from '@emotion/styled';
import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';
import {
  FeaturedImageWrapper,
  StyledBackgroundImage,
  StyledForegroundImage,
  StyledPicture,
} from './FeaturedImage.styles';
import { StyledHeading } from './HighlightTitle.styles';

export const GridWrapper = styled.div`
  display: grid;
  max-width: 1920px;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const HoverWrapper = styled.div`
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: ${COLORS3.WHITE_100};

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    display: none;
  }
`;

export const HoverDek = styled.p`
  margin: ${SPACING.LG} 0;
  color: ${COLORS3.WHITE_100};
  text-align: center;

  ${MEDIA_QUERY.MOBILE} {
    margin: ${SPACING.MD} 0;
  }
`;

export const GridItemWrapper = styled.div<{
  hasHoverState?: boolean;
}>`
  text-align: center;
  border-bottom: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
  position: relative;
  aspect-ratio: 1;

  &:nth-of-type(2),
  :nth-of-type(5),
  :nth-of-type(8) {
    border-left: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
    border-right: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
  }

  ${StyledBackgroundImage},
  ${FeaturedImageWrapper} {
    border-radius: 0;
  }

  ${FeaturedImageWrapper},
  ${StyledBackgroundImage},
  ${StyledPicture} {
    height: 100%;
  }

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    :nth-of-type(5),
    :nth-of-type(8) {
      border-left: none;
      border-right: none;
    }

    &:nth-of-type(2),
    :nth-of-type(4),
    :nth-of-type(6) {
      border-left: var(--border-grid, 1px solid ${COLORS3.BLACK_030});
      border-right: none;
    }
  }

  ${MEDIA_QUERY.DESKTOP} {
    &:hover,
    &:focus-within {
      ${HoverWrapper} {
        opacity: 1;
        pointer-events: auto;
      }

      ${StyledForegroundImage} {
        display: ${(props) => (props.hasHoverState ? 'none' : 'initial')};
      }

      ${StyledBackgroundImage}:before {
        display: block;
      }
    }
  }
`;

export const GridTextWrapper = styled(GridItemWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${StyledHeading} {
    max-width: 320px;

    ${MEDIA_QUERY.MOBILE_XS} {
      max-width: 164px;
      ${FONT.textSizeUltraCompact(FONT.SIZE.REGULAR)};
    }
  }

  a {
    align-self: center;
    margin-top: ${SPACING.S32};

    ${MEDIA_QUERY.MOBILE_XS} {
      font-size: ${FONT.FONT_SIZE_SMALLER};
      margin-top: ${SPACING.S16};
    }

    ${MEDIA_QUERY.TABLET} {
      margin-top: ${SPACING.S24};
    }
  }
`;
